import { ChangeDetectionStrategy, ChangeDetectorRef, Component } from "@angular/core";
import { BaseFormComponent } from "projects/sepidz-web-framework-shell/src/lib/shared/controls/base/base-form.component";
import { SelectorService } from "projects/sepidz-web-framework-shell/src/lib/shared/controls/base/selector.service";
import { form_control } from "projects/sepidz-web-framework/src/lib/models";
import * as moment from "moment";
import { takeUntil } from "rxjs/operators";
import { Invoice } from "src/app/frontoffice/order/model/invoice.model";
import { Rahkaran } from "../rahkaran.model";

@Component({
  selector: "ngx-rahkaran-form",
  templateUrl: "./rahkaran-form.component.html",
  styleUrls: ["./rahkaran-form.component.scss"],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class RahkaranFormComponent extends BaseFormComponent<Rahkaran> {
  deactivateSave: boolean = false;
  erroremessage: string;
  itemColumns: form_control[];
  DateNow: string;
  invoiceList: Invoice[];
  constructor(protected selectorService: SelectorService, protected cd: ChangeDetectorRef) {
    super(selectorService, cd);
  }

  async ngOnInit() {
    this.apiName = "Rahkaran";
    this.label = this.translate("ClientApp.Pages.PageMenu.Rahkaran");
    super.ngOnInit();
    const m = moment();
    this.DateNow = m.locale("fa").format("YYYY/MM/DD");
  }

  SetInvoiceFactor() {
    this.model.StartDate = this.formGroup.controls["StartDate"].value;
    this.model.EndDate = this.formGroup.controls["EndDate"].value;
    this.httpCommonService
      .create("Rahkaran/GetRahkaranInvoices", this.model)
      .pipe(takeUntil(this.ngUnsubscribe))
      .subscribe(
        (data: any) => {
          this.invoiceList = data.Data;
        },
        (err) => {
          console.log(err);
        }
      );
  }

  setdefault(): void {
    if (!this.model.StartDate) this.model.StartDate = this.DateNow as any;
    if (!this.model.EndDate) this.model.EndDate = this.DateNow as any;
  }

  addControl(): void {
    this.setValue("StartDate", this.model.StartDate);
    this.setValue("EndDate", this.model.EndDate);
  }
  async save() {
    this.SetInvoiceFactor();
  }
}
